// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NGDD","footer":"styles_footer__J8BpS"};